const fonts = {
  primary: "Pelita Std-Regular",
  primaryBold: "Pelita Std-Bold",
  secondary: "Pelita Grande Std-Regular",
  secondaryBold: "Pelita Grande Std-Bold",
};

export default fonts;
